import { render, staticRenderFns } from "./NotFoundPage.vue?vue&type=template&id=681caac6&"
var script = {}
import style0 from "./NotFoundPage.vue?vue&type=style&index=0&id=681caac6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports